import React, { useEffect,useState } from "react";
import './contentH5.scss'

function ContentH5(props) {
    const tabList = [{label:'实名认证',type:1},{label:'收付款',type:2},{label:'买币教程',type:3},{label:'卖币教程',type:4}]
    const walletEntryList = [
        {num:1,des:'点击我的钱包',src:'assets/entry/1.png'},
        {num:2,des:'点击启用激活钱包,进入钱包',src:'assets/entry/2.png'},
    ]
    const mobileRechargeList = [
        {num:1,des:'打开我的钱包,点击OBPAY钱包,输入金额',src:'assets/mobileRecharge/1.png'},
    ]
    const mobileWithdrawList = [
        {num:1,des:'点击我要提现',src:'assets/mobileWithdrawList/1.png'},
        {num:2,des:'点击银行卡管理',src:'assets/mobileWithdrawList/2.png'},
        {num:3,des:'点击添加新的账号',src:'assets/mobileWithdrawList/3.png'},
        {num:4,des:'选择OBPAY钱包,输入信息,点击提交',src:'assets/mobileWithdrawList/4.png'},
        {num:5,des:'输入提现金额,点击提交',src:'assets/mobileWithdrawList/5.png'},
    ]
    const pcRechargeList = [
        {num:1,des:'点击我要存款',src:'assets/pcRechargeList/1.png'},
        {num:2,des:'点击我的钱包,选择OBPAY钱包,输入充值金额提交',src:'assets/pcRechargeList/2.png'},
    ]
    const pcWithdrawList = [
        {num:1,des:'点击我要提款',src:'assets/pcWithdrawList/1.png'},
        {num:2,des:'点击出款银行卡,新增收款账号',src:'assets/pcWithdrawList/2.png'},
        {num:3,des:'选择OBPAY钱包,输入信息,点击提交',src:'assets/pcWithdrawList/3.png'},
        {num:4,des:'点击取款',src:'assets/pcWithdrawList/4.png'},
        {num:5,des:'点击我要继续出款',src:'assets/pcWithdrawList/5.png'},
        {num:6,des:'输入信息,点击确定送出',src:'assets/pcWithdrawList/6.png'},
    ]
    const tabContentList = {
            1:[
                {num:1,des:'点击[我的]去实名',src:'assets/verified/1.png'},
                {num:2,des:'上传身份信息，点击[下一步]进行认证',src:'assets/verified/2.png'},
                {num:3,des:'审核通过会出现[已认证]标志',src:'assets/verified/3.png'}
            ],
            2:[
                {num:1,des:'点击[添加收付款]信息进行下一步',src:'assets/add/1.png'},
                {num:2,des:'填写收款方式点击[下一步]进行认证审核',src:'assets/add/2.png'},
                {num:3,des:'审核通过会出现[已审核]标志',src:'assets/add/3.png'}
            ],
            3:[
                {num:1,des:'在APP首页的交易市场选择订单点击[购买]',src:'assets/buy/1.png'},
                {num:2,des:'选择购买数量以及支付方式点击[买入]',src:'assets/buy/2.png'},
                {num:3,des:'创建订单成功，等待卖家确认交易[若卖家超时未确认，交易将自动取消]',src:'assets/buy/3.png'},
                {num:4,des:'卖家确认交易后，按照卖家收款信息进行转账，并点击 [通知卖家] ,等待卖家打币',src:'assets/buy/4.png'},
                {num:5,des:'如有纠纷点击右上角[客服]图标申请客服介入',src:'assets/buy/5.png'}
            ],
            4:[
                {num:1,des:'点击APP首页[出售]按钮',src:'assets/sell/1.png'},
                {num:2,des:'选择收款方式和数量，点击[确定挂单],卖币订单创建成功，等待买家购买！',src:'assets/sell/2.png'},
                {num:3,des:'买家下单后，进入订单，点击[同意交易]，等待买家转账付款',src:'assets/sell/3.png'},
                {num:4,des:'收到买家付款后，点击[确认打币]，输入密码交易完成',src:'assets/sell/4.png'},
                {num:5,des:'若遇纠纷，可点击[暂停打币]，点击右上角[客服]图标申请客服介入',src:'assets/sell/5.png'}
            ],
        }
    const [heightH5,setHeightH5] = useState(0)
    const [tabType,setTabType] = useState(1)
    useEffect(() => {
        const h = window.innerHeight
        setHeightH5(h)
    }, [])
    const tabClick = (type) => {
        setTabType(type)
    }
    return (
        <>
            <div className="content_h5" style={{height:heightH5}}>
                <div className="title">
                    <h1>直连教程</h1>
                    {/* <p>寻找一次很棒的体验</p> */}
                </div>
                {/* 内置钱包,进入教程 */}
                <div className="video_content graphics_content dr_graphics_content">
                    <div className="video_title graphics_title">内置钱包,进入教程</div>
                    <div className="graphics">
                        <div className="graphics_content1">
                            {walletEntryList.map(item => {
                                return (
                                    <div key={item.num} className="graphics_content1_one">
                                        <p className="graphics_content1_one_math">0{item.num}</p>
                                        <p className="graphics_content1_one_title">{item.des}</p>
                                        <div className="graphics_content1_one_img">
                                            <img src={item.src} alt=""></img>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {/* 图文教程 */}
                <div className="video_content graphics_content">
                    <div className="video_title graphics_title">图文教程</div>
                    <div className="graphics">
                        <div className="graphics_tab">
                            {tabList.map((item) => {
                                return (<div key={item.type} className={`graphics_tab_one ${tabType===item.type?'graphics_tab_one_active':null}`} onClick={() => {tabClick(item.type)}}>{item.label}</div>)
                            })}
                        </div>
                        <div className="graphics_content1">
                            {tabContentList[tabType].map(item => {
                                return (
                                    <div key={item.num} className="graphics_content1_one">
                                        <p className="graphics_content1_one_math">0{item.num}</p>
                                        <p className="graphics_content1_one_title">{item.des}</p>
                                        <div className="graphics_content1_one_img">
                                            <img src={item.src} alt=""></img>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {/* 手机版充值教程 */}
                <div className="video_content graphics_content dr_graphics_content">
                    <div className="video_title graphics_title">手机版充值教程</div>
                    <div className="graphics">
                        <div className="graphics_content1">
                            {mobileRechargeList.map(item => {
                                return (
                                    <div key={item.num} className="graphics_content1_one">
                                        <p className="graphics_content1_one_math">0{item.num}</p>
                                        <p className="graphics_content1_one_title">{item.des}</p>
                                        <div className="graphics_content1_one_img">
                                            <img src={item.src} alt=""></img>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {/* 手机版提现教程 */}
                <div className="video_content graphics_content dr_graphics_content">
                    <div className="video_title graphics_title">手机版提现教程</div>
                    <div className="graphics">
                        <div className="graphics_content1">
                            {mobileWithdrawList.map(item => {
                                return (
                                    <div key={item.num} className="graphics_content1_one">
                                        <p className="graphics_content1_one_math">0{item.num}</p>
                                        <p className="graphics_content1_one_title">{item.des}</p>
                                        <div className="graphics_content1_one_img">
                                            <img src={item.src} alt=""></img>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {/* 电脑版充值教程 */}
                <div className="video_content graphics_content dr_graphics_content">
                    <div className="video_title graphics_title">电脑版充值教程</div>
                    <div className="graphics">
                        <div className="graphics_content1">
                            {pcRechargeList.map(item => {
                                return (
                                    <div key={item.num} className="graphics_content1_one">
                                        <p className="graphics_content1_one_math">0{item.num}</p>
                                        <p className="graphics_content1_one_title">{item.des}</p>
                                        <div className="graphics_content1_one_img">
                                            <img src={item.src} alt=""></img>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {/* 电脑版提现教程 */}
                <div className="video_content graphics_content dr_graphics_content">
                    <div className="video_title graphics_title">电脑版提现教程</div>
                    <div className="graphics">
                        <div className="graphics_content1">
                            {pcWithdrawList.map(item => {
                                return (
                                    <div key={item.num} className="graphics_content1_one">
                                        <p className="graphics_content1_one_math">0{item.num}</p>
                                        <p className="graphics_content1_one_title">{item.des}</p>
                                        <div className="graphics_content1_one_img">
                                            <img src={item.src} alt=""></img>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ContentH5